import { gql } from '../../../../../hooks'

export const DELETE_SAMPLES = gql`
  mutation AdministrationDeleteSamplingSamples($id: ID!) {
    aDelete(path: "sampling/samples", id: $id) {
    }
  }
`

export const LIST_SAMPLES = gql`
  query AdministrationListSamplingSamples(
    $page: Int
    $limit: Int
    $filter: JSONObject
  ) {
    aList(
      path: "sampling/samples"
      filter: $filter
      page: $page
      limit: $limit
    ) {
      pagination {
        page
        limit
        number_of_pages
      }
    }
  }
`
